import React, { useState, useEffect } from 'react';

const Toast = ({ message, type = 'success', duration = 3200, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onClose?.(), 280);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const themes = {
    success: {
      shell: 'bg-white text-gray-900 border-orange-200/80',
      iconWrap: 'bg-orange-500 text-white',
      icon: (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      )
    },
    error: {
      shell: 'bg-white text-gray-900 border-red-200/80',
      iconWrap: 'bg-red-500 text-white',
      icon: (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      )
    },
    warning: {
      shell: 'bg-white text-gray-900 border-amber-200/80',
      iconWrap: 'bg-amber-500 text-white',
      icon: (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        </svg>
      )
    },
    info: {
      shell: 'bg-white text-gray-900 border-stone-200',
      iconWrap: 'bg-stone-800 text-white',
      icon: (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
        </svg>
      )
    }
  };

  const theme = themes[type] || themes.info;

  if (!visible) return null;

  return (
    <div
      role="status"
      className={`fixed top-5 right-4 z-[100] max-w-sm w-[calc(100%-2rem)] sm:w-auto
        ${theme.shell} border shadow-[0_12px_40px_-12px_rgba(15,23,42,0.28)]
        pl-3 pr-3 py-3 rounded-2xl flex items-center gap-3
        transform transition-all duration-300 ease-out
        ${visible ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-0'}`}
    >
      <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${theme.iconWrap}`}>
        {theme.icon}
      </span>
      <span className="font-medium text-sm leading-snug pr-1">{message}</span>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => {
          setVisible(false);
          setTimeout(() => onClose?.(), 280);
        }}
        className="flex-shrink-0 ml-1 w-7 h-7 rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 flex items-center justify-center transition-colors"
      >
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default Toast;
